/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_License_DescriptionInputs */

const en_marketing_license_description = /** @type {(inputs: Marketing_License_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Own the code. Build your product on it.`)
};

const es_marketing_license_description = /** @type {(inputs: Marketing_License_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código es tuyo. Construye tu producto sobre él.`)
};

const fr_marketing_license_description = /** @type {(inputs: Marketing_License_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le code vous appartient. Construisez votre produit dessus.`)
};

/**
* | output |
* | --- |
* | "Own the code. Build your product on it." |
*
* @param {Marketing_License_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_license_description = /** @type {((inputs?: Marketing_License_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_License_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_license_description(inputs)
	if (locale === "es") return es_marketing_license_description(inputs)
	return fr_marketing_license_description(inputs)
});